<template>
    <div>
         

        <!---------------Booking Details--------------->
        <section class="container-fluid booking-details">
            <div class="container lg-container">
                <div class="row">
                    <div class="col-sm box drivers d-flex flex-column align-items-center">
                        <span class="number">35</span>
                        <span class="title">Drivers</span>
                    </div>
                    <div class="col-sm box delivery d-flex flex-column align-items-center">
                        <span class="number">75</span>
                        <span class="title">Complete Delivery</span>
                    </div>
                    <div class="col-sm box pickup d-flex flex-column align-items-center">
                        <span class="number">25</span>
                        <span class="title">Pending Pickup</span>
                    </div>
                    <div class="col-sm box transit d-flex flex-column align-items-center">
                        <span class="number">10</span>
                        <span class="title">Deliveries in Transit</span>
                    </div>
                </div>
            </div>
        </section>

        <!-------------------Booking Form------------------->
        <section class="container-fluid chng-pd-container">
            <div class="container form-container">
                <div class="row">
                    <form class="w-100">
                        <div class="heading">
                            <h2>SET COURIER RATE</h2>
                        </div>
                        <div class="form-row">
                            <div class="col-lg-8">

                                <div class="d-flex flex-row">
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="inputEmail4"
                                        placeholder=""
                                    >
                                </div>
                            </div>

                            <div
                                class="col-lg-4 button justify-content-end d-flex flex-row align-items-center courier-btn"
                                style="margin-top: 0;"
                            >
                                <div class="btn btn-success">UPDATE</div>
                        </div>
                </div>

                </form>
            </div>
    </div>
    </section>

    <!-----------------Footer------------------>

     
    </div>

</template>

<script>
 
export default {
  name: "Account_verify",
  components: {
     
  },
  data() {
    return {};
  },

  methods: {}
};
</script>

<style scoped>
</style>